import script from "./NewReleasesBooksBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewReleasesBooksBlock.vue?vue&type=script&setup=true&lang=ts"

import "./NewReleasesBooksBlock.vue?vue&type=style&index=0&id=1a603467&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a603467"]])

export default __exports__